import React, { useEffect, useState } from "react";
import useSizePercentage from "../hooks/useSizePercentage";
import BackButton from "../misc/elements/BackButton";
import SortBar from "../misc/elements/SortBar";
import boxStore from "../stores/boxStore";
import collectionStore from "../stores/collectionStore";
import DetailedButton from "./../detailedView/DetailedButton";
import OverviewButtonsBar from "./OverviewButtonsBar";
import SelectedBoxTypesBar from "./SelectedBoxTypesBar";
import SelectedTypesList from "./SelectedTypesList";

const BoxTypeOverview = () => {
  const sizePercentage = useSizePercentage();
  const { boxTypeOverview, resetBoxTypeOverview } = boxStore();
  const [selectedCollection, setSelectedCollection] = useState("open");
  const [typeNames, setTypeNames] = useState([]);
  const { open, saved, history } = collectionStore();

  useEffect(() => {
    if (boxTypeOverview.length > 0) {
      const typeNames = boxTypeOverview.map((bt) => bt.names.plural);
      setTypeNames(typeNames);
    }
  }, [boxTypeOverview]);

  function onOverviewButtonClicked(payload) {
    console.log("payload - ", payload);
    setSelectedCollection(payload);
  }
  return (
    <div
      className="divColumn"
      style={{
        width: `${(1200 / 100) * sizePercentage.width}px`,
        minWidth: "800px",
        height: "50%",
        minHeight: "500px",
        borderRadius: "1rem/1rem",
        border: "5px solid grey",
        position: "relative",
        marginLeft: `${(20 / 100) * sizePercentage.width}%`,
        backgroundColor: "#efefef",
      }}
    >
      <div
        className="divRow"
        style={{ position: "absolute", left: 0, marginLeft: "5px", top: 2 }}
      >
        <BackButton onClick={() => resetBoxTypeOverview()} />
      </div>
      <SelectedBoxTypesBar boxTypeOverview={boxTypeOverview} />
      <OverviewButtonsBar
        onOverviewButtonClicked={onOverviewButtonClicked}
        selectedCollection={selectedCollection}
      />
      <SortBar />
      <SelectedTypesList
        selectedCollection={selectedCollection}
        boxTypes={boxTypeOverview}
      />
    </div>
  );
};

export default BoxTypeOverview;
